// src/pages/PrivacyPolicyPage.js
import React from 'react';
import Navbar from '../components/Navbar';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Fix overlay Navbar: spacer sotto la headbar (regola h-20 se la Navbar è più alta/bassa) */}
      <div className="h-20" />

      <div className="container mx-auto px-6 pb-40 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>

        <Card>
          <CardHeader>
            <CardTitle>Informativa Privacy ai sensi dell&apos;art. 13 Reg. UE 2016/679 (GDPR)</CardTitle>
          </CardHeader>

          <CardContent className="prose max-w-none">
            <div className="space-y-8">
              <section>
                <p className="text-gray-700 font-semibold">
                  La presente informativa descrive le modalità di trattamento dei dati personali effettuato da
                  Base (di seguito anche “Associazione” o “Titolare”) in relazione all’utilizzo del sito,
                  all’accesso all’area riservata e alla gestione delle richieste e delle attività associative, in conformità
                  al Regolamento (UE) 2016/679 (“GDPR”) e alla normativa nazionale applicabile.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">1. Titolare del Trattamento</h2>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-gray-700">
                    <strong>Titolare del trattamento:</strong> Base<br />
                    <strong>Sede legale:</strong> Via del Plebiscito 112, 00186 - Roma (RM)<br />
                    <strong>Email di contatto:</strong>{' '}
                    <a href="mailto:info@acbase.org" className="text-blue-600 hover:underline">
                      info@acbase.org
                    </a>
                  </p>
                  <p className="text-sm text-gray-600 mt-3">
                    Il Titolare non ha nominato un Responsabile della Protezione dei Dati (DPO), in quanto non ricorrono i
                    presupposti previsti dall’art. 37 del GDPR.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">2. Ambito di applicazione</h2>
                <p className="text-gray-700">
                  La presente informativa si applica al trattamento dei dati personali di:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>utenti che navigano il sito;</li>
                  <li>soggetti che inviano richieste di contatto e/o candidature/iscrizioni;</li>
                  <li>membri che accedono e utilizzano l’area riservata.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">3. Tipologie di dati trattati</h2>
                <p className="text-gray-700 mb-4">
                  A seconda delle funzionalità utilizzate, l’Associazione può trattare le seguenti categorie di dati:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    <strong>Dati identificativi e di contatto:</strong> nome, cognome, e-mail, telefono,
                    indirizzo (se necessario per finalità associative/amministrative), e altri dati conferiti dall’interessato.
                  </li>
                  <li>
                    <strong>Dati associativi e amministrativi:</strong> informazioni necessarie per la gestione della candidatura/iscrizione,
                    della membership, delle comunicazioni istituzionali e delle attività associative.
                  </li>
                  <li>
                    <strong>Dati economici (quote associative):</strong> informazioni inerenti alla gestione delle quote (es. stato quota,
                    riscontri amministrativi/contabili). Il sito non è destinato a raccogliere dati completi di carte di pagamento, salvo
                    diversa indicazione e canali dedicati.
                  </li>
                  <li>
                    <strong>Dati tecnici e di navigazione:</strong> indirizzo IP, user agent, data/ora delle richieste, log tecnici e di sicurezza,
                    informazioni su dispositivo/browser, identificativi tecnici necessari al funzionamento e alla protezione del servizio.
                  </li>
                  <li>
                    <strong>Area riservata (autenticazione OTP):</strong> l’accesso avviene tramite <strong>OTP (One-Time Password)</strong> inviato via e-mail,
                    senza utilizzo di password e senza funzionalità “remember me”.
                  </li>
                </ul>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-4">
                  <p className="text-sm text-yellow-800">
                    <strong>Dati particolari (art. 9 GDPR):</strong> l’Associazione non richiede, di regola, dati particolari
                    (es. salute, convinzioni religiose, opinioni politiche, orientamento sessuale). Si invita a non inserirli nei campi liberi.
                    Qualora fossero conferiti spontaneamente e non richiesti, saranno trattati nei limiti strettamente necessari alla gestione
                    della richiesta o degli obblighi applicabili.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">4. Finalità del trattamento</h2>

                <div className="space-y-4">
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <h3 className="font-semibold text-blue-900 mb-2">A) Finalità necessarie (senza consenso)</h3>
                    <ul className="list-disc list-inside space-y-1 text-sm text-blue-800">
                      <li>Gestione di richieste di contatto e riscontro a comunicazioni pervenute.</li>
                      <li>Valutazione candidature/iscrizioni e gestione del rapporto associativo (membership e attività).</li>
                      <li>Gestione dell’area riservata (OTP, sessione, controlli tecnici e di sicurezza).</li>
                      <li>Adempimenti amministrativi, contabili e fiscali connessi alla vita associativa.</li>
                      <li>Sicurezza dei sistemi, prevenzione di abusi/frodi, tutela dei diritti del Titolare.</li>
                    </ul>
                  </div>

                  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <h3 className="font-semibold text-green-900 mb-2">B) Finalità facoltative (solo se previste)</h3>
                    <ul className="list-disc list-inside space-y-1 text-sm text-green-800">
                      <li>Invio di newsletter e comunicazioni non strettamente istituzionali (se attivate).</li>
                      <li>Pubblicazione di foto/video di eventi su sito e/o canali social (se attivata e ove necessario).</li>
                    </ul>
                    <p className="text-sm text-green-800 mt-2">
                      Le attività facoltative sono svolte esclusivamente quando previste e, ove richiesto, sulla base di un consenso
                      valido e revocabile.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">5. Base giuridica del trattamento</h2>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    <strong>Art. 6(1)(b) GDPR:</strong> esecuzione di misure precontrattuali/contrattuali (es. gestione richieste,
                    candidatura/iscrizione, erogazione servizi e gestione membership).
                  </li>
                  <li>
                    <strong>Art. 6(1)(c) GDPR:</strong> adempimento di obblighi di legge (amministrativi/contabili/fiscali).
                  </li>
                  <li>
                    <strong>Art. 6(1)(f) GDPR:</strong> legittimo interesse (sicurezza informatica, prevenzione abusi, continuità del servizio,
                    tutela dei diritti del Titolare).
                  </li>
                  <li>
                    <strong>Art. 6(1)(a) GDPR:</strong> consenso (solo ove necessario e solo per finalità facoltative).
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">6. PostHog (product analytics) e minimizzazione</h2>
                <p className="text-gray-700 mb-4">
                  Il sito può utilizzare <strong>PostHog</strong> per finalità di analisi tecnica e miglioramento del servizio
                  (product analytics). L’implementazione è configurata, ove possibile, in modalità <strong>cookieless</strong>
                  e con criteri di minimizzazione, evitando l’impiego di strumenti di marketing/profilazione e limitando la raccolta
                  ai soli eventi tecnici necessari per comprendere e migliorare stabilità, performance e funzionamento delle funzionalità.
                </p>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h3 className="font-semibold text-blue-900 mb-2">Principi applicati</h3>
                  <ul className="list-disc list-inside space-y-1 text-sm text-blue-800">
                    <li>Raccolta minimizzata e proporzionata (eventi tecnici e di utilizzo in forma aggregabile).</li>
                    <li>Assenza di advertising, pixel e tag di marketing.</li>
                    <li>Assenza di intenzione di identificazione diretta dell’utente tramite PostHog, salvo necessità documentata.</li>
                    <li>Retention limitata e misure organizzative coerenti con le finalità dichiarate.</li>
                  </ul>
                </div>

                <p className="text-gray-700 mt-4">
                  Se in futuro venissero introdotte modalità di tracciamento che richiedano consenso (ad es. cookie non tecnici o identificativi
                  persistenti per finalità diverse da quelle tecniche), il Titolare aggiornerà l’informativa e, ove necessario, adotterà un
                  meccanismo di acquisizione del consenso.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">7. Cloudflare e sicurezza</h2>
                <p className="text-gray-700">
                  Il sito utilizza <strong>Cloudflare</strong> come servizio di sicurezza e ottimizzazione (CDN/WAF). Cloudflare può trattare dati tecnici
                  (es. indirizzo IP e richieste HTTP) e utilizzare identificativi tecnici necessari alla protezione da traffico malevolo e attacchi,
                  nonché alla continuità del servizio.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">8. Destinatari dei dati</h2>
                <p className="text-gray-700 mb-4">
                  I dati possono essere trattati da soggetti autorizzati dal Titolare e/o comunicati, nei limiti necessari, a soggetti esterni
                  che operano quali <strong>Responsabili del trattamento</strong> (art. 28 GDPR) o quali autonomi titolari, tra cui:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>fornitori IT e hosting (Italia/UE) e manutentori tecnici;</li>
                  <li>fornitori di sicurezza/distribuzione contenuti (CDN/WAF);</li>
                  <li>fornitori di analytics tecnici (PostHog), se attivati e configurati come descritto;</li>
                  <li>consulenti amministrativi/contabili, se necessario;</li>
                  <li>autorità competenti, nei casi previsti dalla legge.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">9. Trasferimento di dati extra-UE</h2>
                <p className="text-gray-700">
                  Il sito è ospitato in <strong>Italia (Unione Europea)</strong>. Eventuali trasferimenti verso Paesi extra-UE avverranno solo se necessari e
                  nel rispetto degli artt. 44 e ss. GDPR (es. decisioni di adeguatezza, SCC e misure supplementari ove richiesto).
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">10. Periodi di conservazione</h2>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    <strong>Dati associativi/amministrativi:</strong> per la durata del rapporto e per il tempo necessario a gestire obblighi o contestazioni.
                  </li>
                  <li>
                    <strong>Dati contabili/fiscali:</strong> secondo i termini di legge (di norma fino a 10 anni).
                  </li>
                  <li>
                    <strong>Log tecnici e di sicurezza:</strong> per un periodo limitato e proporzionato alle finalità di sicurezza 90 giorni),
                    salvo necessità di ulteriore conservazione in caso di incidenti o richieste dell’autorità.
                  </li>
                  <li>
                    <strong>Eventi tecnici PostHog (se attivo):</strong> retention limitata coerente con le finalità (6 mesi).
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">11. Diritti dell&apos;interessato</h2>
                <p className="text-gray-700 mb-4">
                  Ai sensi degli artt. 15-22 del GDPR, l’interessato può esercitare: accesso, rettifica, cancellazione, limitazione,
                  portabilità (ove applicabile), opposizione, nonché revoca del consenso (se prestato), senza pregiudicare la liceità
                  del trattamento basata sul consenso prima della revoca.
                </p>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                  <p className="text-sm text-yellow-800">
                    <strong>Per esercitare i diritti,</strong> inviare una richiesta a:{' '}
                    <a href="mailto:info@acbase.org" className="font-semibold text-blue-600 hover:underline">
                      info@acbase.org
                    </a>
                    .
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">12. Diritto di reclamo</h2>
                <p className="text-gray-700">
                  L&apos;interessato ha il diritto di proporre reclamo al <strong>Garante per la Protezione dei Dati Personali</strong> qualora ritenga
                  che il trattamento dei dati sia effettuato in violazione del GDPR.
                </p>

                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mt-4">
                  <p className="text-sm text-gray-700">
                    <strong>Garante per la Protezione dei Dati Personali</strong><br />
                    Piazza Venezia, 11 - 00187 Roma<br />
                    Tel: +39 06.696771<br />
                    Email:{' '}
                    <a href="mailto:garante@gpdp.it" className="text-blue-600 hover:underline">
                      garante@gpdp.it
                    </a>
                    <br />
                    PEC:{' '}
                    <a href="mailto:protocollo@pec.gpdp.it" className="text-blue-600 hover:underline">
                      protocollo@pec.gpdp.it
                    </a>
                    <br />
                    Web:{' '}
                    <a
                      href="https://www.garanteprivacy.it"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      www.garanteprivacy.it
                    </a>
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">13. Aggiornamenti</h2>
                <p className="text-gray-700">
                  La presente informativa può essere soggetta a modifiche. Si consiglia di consultare regolarmente questa pagina per rimanere
                  aggiornati su eventuali modifiche.
                </p>
              </section>

              <section className="pt-6 border-t">
                <p className="text-sm text-gray-500">
                  Ultimo aggiornamento: Gennaio 2026 — Contatti: info@acbase.org
                </p>
              </section>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
